/**
 * This barrel file provides the export for the lazy loaded LoginModule.
 */
export * from './terms.component';
export  * from './terms.route';
export  * from './terms.module';
